
export class SectionsWithNav
{

    constructor(element)
    {
        this.element = element;
        this.sections = {};
        this.navItems = {};
        this.progressBars = {};

        this.nav = element.querySelector('[data-sections-with-nav-nav]');

        [...element.querySelectorAll('[data-sections-with-nav-button]')].forEach((navItem) => {
            this.navItems[navItem.dataset.sectionsWithNavButton] = {
                id: navItem.dataset.sectionsWithNavButton,
                element: navItem,
            }
        });
        [...element.querySelectorAll('[data-sections-with-nav-progress-bar]')].forEach((progressBar) => {
            this.progressBars[progressBar.dataset.sectionsWithNavProgressBar] = {
                id: progressBar.dataset.sectionsWithNavProgressBar,
                element: progressBar,
            }
        })

        this.init();
        this.addEventListeners();
        this.observeNav();
        this.onScroll();
    }

    init()
    {
        this.elementTop = window.pageYOffset + this.element.getBoundingClientRect().y;
        this.element.querySelectorAll('[data-sections-with-nav-section]').forEach((section) => {
            const rect = section.getBoundingClientRect();
            this.sections[section.dataset.sectionsWithNavSection] = {
                id: section.dataset.sectionsWithNavSection,
                height: section.clientHeight,
                rect: rect,
                progress: 0,
                element: section,
                top: section.offsetTop,
            };
        });
    }

    addEventListeners()
    {
        [...Object.values(this.navItems)].forEach((navItem) => {
            navItem.element.addEventListener('click', this.onClick.bind(this), false);
        });

        window.addEventListener('resize', function()
        {
            if (!this.resizeTicking)
            {
                window.requestAnimationFrame(function()
                {
                    this.init();
                    this.resizeTicking = false;
                }.bind(this));
            }
        }.bind(this));
        window.addEventListener('scroll', function()
        {
            if (!this.scrollTicking)
            {
                window.requestAnimationFrame(function()
                {
                    this.onScroll();
                    this.scrollTicking = false;
                }.bind(this));
            }
        }.bind(this));
    }

    onClick(e)
    {
        e.preventDefault();
        let id = e.target.dataset.sectionsWithNavButton;
        let element = this.sections[id].element;
        const y = window.pageYOffset + element.getBoundingClientRect().y - 70;
        if (window.smoothScrollSupported)
        {
                window.scrollTo({
                    top: y,
                    left: 0,
                    behavior: 'smooth',
                });
        }
        else
        {
            window.scrollTo(0, y);
        }
    }

    observeNav()
    {
        const observer = new IntersectionObserver(
            ([e]) => this.nav.classList.toggle('is-sticky', e.intersectionRatio < 1),
            {threshold: [1]}
        );

        observer.observe(this.nav.querySelector('[data-sections-with-nav-sentinel]'));
    }

    onScroll()
    {
        const currentScrollPosition = (window.pageYOffset + (window.innerHeight / 2)) - this.elementTop;

        Object.keys(this.sections).forEach((sectionId) => {
            let section = this.sections[sectionId];
            switch (true) {
                case (section.top + section.height < currentScrollPosition):
                    section.progress = 1;
                    break;
                case (section.top > currentScrollPosition):
                    section.progress = 0;
                    break;
                default:
                    section.progress = (currentScrollPosition - section.top) / section.height;
                    break;
            }
            this.progressBars[sectionId].element.value = section.progress;
        });
    }

}